// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231905/js/" + chunkId + "." + {"44":"4a3505b6","225":"531b2cee","481":"f69634f7","486":"632cd854","770":"3c1fed9e"}[chunkId] + ".0.8512123010842567.chunk.js";
};